import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TitleMachineService {
  private readonly titleService = inject(Title);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);

  // todo change with angular v14 --- https://github.com/angular/angular/pull/43307
  // and a custom tile resolver for the static customer files -- StaticCustomerFileViewerComponent
  public run(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;

          while (route?.firstChild) {
            route = route.firstChild;
          }

          let title = route?.snapshot?.data?.['title'] ?? '';
          if (title === 'statics') {
            title = `page_names.${route.snapshot.params['name']}`;
          }

          return title;
        }),
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(this.translate.instant(title));
        } else {
          throw new Error(`no page title set in router config`);
        }
      });
  }
}
